import { useMutation } from 'react-query';
import request from '../../../helpers/request';
import { useDispatch, useSelector } from 'react-redux';
import { requestsConstants } from '../requests.constants';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const postAddress = async ({ requestId, ...values }) => {
  return await request.put(
    `/Request/set_address/${requestId}`,
    values,
    'При изменение заявки произошла ошибка',
    'Error'
  );
};

const useAddressMutation = () => {
  const dispatch = useDispatch();

  const requests = useSelector((state) => state.requestsStore.requests);

  const req = requests.slice();

  return useMutation(postAddress, {
    onSuccess: (data, { requestId }) => {
      if (data === 'Error') return;

      const reqindex = req?.findIndex((item) => item.id === requestId);

      const rurl = `/Request?requestId=${requestId}`;

      dispatch({
        type: requestsConstants.SET_REQUEST_ADDRESS,
        payload: client
          .get(rurl, { headers: authHeader() })
          .then(
            (response) =>
              new Promise((resolve) => {
                req[reqindex] = response.data && response.data[0];
                resolve({ data: req });
              })
          )
          .catch(function (error) {
            console.log(error);
            dispatch({
              type: requestsConstants.POST_ERROR,
              payload: error,
            });
          }),
      });
    },
  });
};

export default useAddressMutation;
